import { gql } from '@apollo/client'

export const CREATE_LEAD = gql`
    mutation CreateLead ($input: CreateLeadInput!) {
        createLead (input: $input) {
            id
        }
    }
`
